import { getCityTranslation } from '@spa/shared/utils/countryTranslation';
import { languageToLocale } from '@spa/shared/utils/language';

const hasIndexableBudgetMax = ({ ['budget-max']: budgetMax }) => {
  if (!budgetMax) {
    return false;
  }

  return (budgetMax / 100) % 50 === 0;
};

const shouldNotBeIndexed = searchQuery => {
  return (
    !(!searchQuery['budget-max'] || hasIndexableBudgetMax(searchQuery)) ||
    !!searchQuery['budget-min'] ||
    !!searchQuery['has-cleaning-service'] ||
    !!searchQuery['guest'] ||
    !!searchQuery['restrictions-occupancy'] ||
    !!searchQuery['min-response-rate'] ||
    !!searchQuery['max-response-time'] ||
    !!searchQuery['has-resident-landlord'] ||
    !!searchQuery['bedrooms'] ||
    !!searchQuery['bathrooms'] ||
    !!searchQuery['ensuite'] ||
    !!searchQuery['bed-type'] ||
    !!searchQuery['offer-features'] ||
    !!searchQuery['property-features'] ||
    !!searchQuery['restrictions-gender'] ||
    !!searchQuery['rules'] ||
    !!searchQuery['has-trusted-landlord'] ||
    !!searchQuery['has-checked-place'] ||
    !!searchQuery['exclusive'] ||
    !!searchQuery['min-avg-rating'] ||
    !!searchQuery['move-in'] ||
    !!searchQuery['move-out'] ||
    !!searchQuery['rent-type'] ||
    !!searchQuery['restrictions-occupation'] ||
    !!searchQuery['housing-type'] ||
    !!searchQuery['guests'] ||
    !!searchQuery['bills-included'] ||
    !!searchQuery['instant-bookings'] ||
    !!searchQuery['flex-move-in'] ||
    !!searchQuery['flex-length'] ||
    !!searchQuery['order'] ||
    !!searchQuery['page']
  );
};

const buildSEO = (fields, location, language) => {
  if (!fields || !location || !language) {
    return null;
  }

  const locale = languageToLocale(language);
  const cityTranslation = getCityTranslation(locale, location.city ?? location);

  return {
    searchQuery: fields,
    isIndexed: !shouldNotBeIndexed(fields) || fields.forceIndex,
    cityTranslation
  };
};

export * from './titles';
export { describeFilters } from './describeFilters';
export { buildSEO };
